export { API_BASE_URL } from '../config/env';
export const REST_API_METHODS = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE',
};
const findStatus = <T extends { key: number }>(
  list: readonly T[],
  key: number | null | undefined,
  fallback: T
): T => {
  if (key === null || key === undefined) return fallback;
  const found = list.find(s => s.key === key);
  return found !== undefined ? found : fallback;
};
// Default currency for the application
export const DEFAULT_CURRENCY = '$';

const STATUSES = [
  { key: 0, label: 'Inactive', color: 'warning' },
  { key: 1, label: 'Acitve', color: 'success' },
] as const;
export const BOOKING_STATUSES = [
  { key: 0, label: 'Pending', color: 'warning' }, // Waiting for admin approval
  { key: 1, label: 'Approved', color: 'info' }, // Approved, awaiting execution
  { key: 2, label: 'In Progress', color: 'primary' }, // Service in progress
  { key: 3, label: 'Completed', color: 'success' }, // Service done, report generated
  { key: 4, label: 'Cancelled', color: 'error' }, // Cancelled before completion
  { key: 5, label: 'Refunded', color: 'secondary' }, // Cancelled + refunded
  { key: 6, label: 'Missed Appointment', color: 'error' }, // Failed to complete
] as const;

const PAYMENT_STATUSES = [
  { key: 0, label: 'Pending', color: 'warning' },
  { key: 1, label: 'Success', color: 'success' },
  { key: 2, label: 'Failed', color: 'error' },
  { key: 3, label: 'Cancelled', color: 'error' },
] as const;

const REPORT_STATUSES = [
  { key: 0, label: 'Pending', color: 'warning' },
  { key: 1, label: 'Completed', color: 'success' },
  { key: 2, label: 'Cancelled', color: 'error' },
] as const;

const PAYMENT_METHODS = [
  { key: 1, label: 'Stripe' },
  { key: 2, label: 'Cash' },
  { key: 3, label: 'Other' },
] as const;

export const STATUS = (key: number | null | undefined) =>
  findStatus(STATUSES, key, { key: 0, label: 'Inactive', color: 'warning' });

export const PAYMENT_STATUS = (key: number | null | undefined) =>
  findStatus(PAYMENT_STATUSES, key, {
    key: 0,
    label: 'Pending',
    color: 'warning',
  });

export const BOOKING_STATUS = (key: number | null | undefined) =>
  findStatus(BOOKING_STATUSES, key, {
    key: 0,
    label: 'Pending',
    color: 'warning',
  });
export const REPORT_STATUS = (key: number | null | undefined) =>
  findStatus(REPORT_STATUSES, key, {
    key: 0,
    label: 'Pending',
    color: 'warning',
  });

export const PAYMENT_METHOD = (key: number | null | undefined) =>
  findStatus(PAYMENT_METHODS, key, { key: 0, label: 'Stripe' });

export * from './Routes.constants';
